import * as React from 'react';
import { Prompt } from 'react-router-dom';
import { useEffect, useCallback } from 'react';

interface IProps {
	when?: boolean | (() => boolean | undefined);
	message?: string;
}

const DirtyPrompt  = ({
	when,
	message = "Opgelet: Er werden wijzigingen aangebracht. Wil je de pagina verlaten zonder op te slaan?" }
	: IProps) => {

	const isDirty = useCallback((): boolean => (typeof when === "function" && when())
											|| (typeof when === "boolean" && when), [when])

	const messageHandler = useCallback(() => isDirty() ? message : true, [isDirty, message])

	const beforePageUnload = useCallback((e: BeforeUnloadEvent) => {		
		if (isDirty()) {
			e.preventDefault();
			return e.returnValue = message;
		}
	}, [message, isDirty]);

	useEffect(() => {
		window.addEventListener('beforeunload', beforePageUnload);
		return () => window.removeEventListener('beforeunload', beforePageUnload);
	}, [when, beforePageUnload]);

	return <Prompt message={messageHandler} />;
}
export default DirtyPrompt;